import React from "react";

const EventCard = ({ event, openModal, handleDelete, formatDate }) => {
  return (
    <div key={event.id} className="event-card">
      <div className="event-info">
        <h3>{event.title || "Untitled Event"}</h3>
        <p className="event-description">
          {(event.description || "").substring(0, 100)}
          {event.description?.length > 100 ? "..." : ""}
        </p>
        <div className="event-meta">
          <p className="event-date">
            <i className="calendar-icon">📅</i> {formatDate(event.dueDate)}
          </p>
          <span className="event-type">
            {event.eventType?.toUpperCase() || "N/A"}
          </span>
        </div>

        <div className="event-tags">
          <span className="event-category">{event.category || "N/A"}</span>
          <span className={`status-badge status-${event.status || "todo"}`}>
            {event.status?.toUpperCase() || "TODO"}
          </span>
          <span
            className={`priority-badge priority-${event.priority || "medium"}`}
            title={`Priority: ${event.priority}`}
          >
            {event.priority?.toUpperCase() || "MEDIUM"}
          </span>
        </div>
      </div>
      <div className="event-actions">
        <button className="edit-btn" onClick={() => openModal(event)}>
          Edit
        </button>
        <button className="delete-btn" onClick={() => handleDelete(event.id)}>
          Delete
        </button>
      </div>
    </div>
  );
};

export default EventCard;
